import React, { Component } from "react";
import { observer, inject } from "mobx-react";
import * as _ from "lodash";

import Toggle from "../../shared/Toggle/Toggle";
import Loader from "../../shared/Loader";
import Swal from "../../shared/Swal";
import "./UnitFilter.scss";

class UnitFilter extends Component {
  constructor(props) {
    super(props);
    this.store = props.store;

    this.toggleAll = this.toggleAll.bind(this);
    this.toggleUnit = this.toggleUnit.bind(this);
    this.store.tempHiddenUnits = this.store.hiddenUnits;
  }
  render() {
    return (
      <div className="unit-filter component">
        {this.store.modalLoading && (
          <div className="loader-wrapper">
            <Loader />
          </div>
        )}
        <button className="btn" onClick={this.toggleAll}>
          Toggle All
        </button>
        {(this.store.filterUnits || []).map((unit) => (
          <div className="unit" key={unit}>
            <Toggle
              label={unit}
              onChange={this.toggleUnit(unit)}
              checked={!_.includes(this.store.tempHiddenUnits, unit)}
            />
          </div>
        ))}
      </div>
    );
  }

  toggleAll(e) {
    e.preventDefault();
    if (this.store.tempHiddenUnits.length) {
      this.store.tempHiddenUnits = [];
    } else {
      this.store.tempHiddenUnits = [...this.store.filterUnits];
    }

    this.forceUpdate();
  }
  toggleUnit(unit) {
    return (e) => {
      if (e.target.checked) {
        this.store.tempHiddenUnits = this.store.tempHiddenUnits.filter(
          (u) => u !== unit,
        );
      } else {
        this.store.tempHiddenUnits = _.uniq([
          ...this.store.tempHiddenUnits,
          unit,
        ]);
      }

      this.forceUpdate();
    };
  }
}

export default inject("store")(observer(UnitFilter));

export function openUnitFilterModal({ patientStore }) {
  if (!patientStore.unitFilterEnabled) return;
  const originalHiddenUnits = [...patientStore.hiddenUnits];
  patientStore.modalLoading = false;
  Swal.fire({
    title: "Filter Units",
    html: <UnitFilter store={patientStore} />,
    confirmButtonText: "OK",
    customClass: "unit-filter",
    showCancelButton: true,
  }).then((e) => {
    patientStore.modalLoading = false;
    if (e.isConfirmed) patientStore.hiddenUnits = patientStore.tempHiddenUnits;
    else patientStore.hiddenUnits = originalHiddenUnits;
  });
}
